import {root} from '../../config';
import vue from 'vue';

function url(api) {
  return root + '/info/' + api;
}

/**
 * 获取其它信息详情
 * @param type
 * @return {*}
 */
export function api_getOthers(type) {
  return vue.http({
    method: 'get',
    url: url('getOthers'),
    params: {
      type: type
    }
  });
}

/**
 * 获取新闻列表
 * @param type
 * @return {*}
 */
export function api_getNews(num) {
  return vue.http({
    method: 'get',
    url: url('getNews'),
    params:{
      num:num
    }
  });
}